import { SET_DEAL_VALIDATION } from './ActionTypes';
export function setDealValidation(dealId, propertyName, validationState) {
  return dispatch => dispatch({
    type: SET_DEAL_VALIDATION,
    payload: {
      dealId,
      propertyName,
      validationState
    }
  });
}